class ReportType {
	static USER_CONTENT_ACTIVITY = "usercontentactivity";
	static USER_ENROLLMENTS = "userenrollments";
	static USERS = "users";
}

export { ReportType };
